import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'

import ApplicationsApi from './api/applicationApi'

const redirectWithEvent = (to, routeName, eventKey) => {
  const api = new ApplicationsApi()

  try {
    api.saveEvent(eventKey)
  } catch (_) {
    //
  }
  return {
    name: routeName,
    query: to.query,
    hash: to.hash,
    replace: true,
  }
}

// import LangRouter from 'vue-lang-router'
// import translations from './plugins/locales'
// import localizedURLs from './plugins/localized-urls'
const { isNavigationFailure, NavigationFailureType } = VueRouter

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch((failure) => {
    if (failure.name === 'NavigationDuplicated') { return }
    if ( !isNavigationFailure(failure, NavigationFailureType.redirected) ) {
      // throw failure
      Vue.prototype.$log( failure )
    }
  })
}
const routerReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function (location) {
  return routerReplace.call(this, location).catch(failure => {
    if (failure.name === 'NavigationDuplicated') { return }
    if ( !isNavigationFailure(failure, NavigationFailureType.redirected) ) {
      // throw failure
      Vue.prototype.$log( failure )
    }
  })
}
Vue.use(VueRouter)
// Vue.use(LangRouter, {
//   defaultLanguage: 'ua',
//   translations,
//   localizedURLs
// })
const baseUrl = window.config.BaseUrl
let routes = [
  {
    path: ':locale?/empty',
    name: 'emptyPage',
    component: () => import('@/public/pages/testPages/emptyPage.vue'),
    caseSensitive: false,    meta: {
      requiresAuth: false,
      without_toolbar: true,
      isMenu: false,
      nolang: true,
    },
  },
  {
    path: ':locale?/:org(\\d+)/tenders/create-new-design',
    name: 'oldNewTender',
    meta: {
      rule: 'onlyTenders',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false,
    beforeEnter: (to, from, next) => {
      next(redirectWithEvent(to, 'newTender', 'REDIRECT_CREATE_TENDER'))
    },
  },
  {
    path: ':locale?/:org(\\d+)/tenders/edit-new-design/',
    name: 'oldEditTender',
    meta: {
      rule: 'onlyTenders',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false,
    beforeEnter: (to, from, next) => {
      next(redirectWithEvent(to, 'editTender', 'REDIRECT_EDIT_TENDER'))
    },
  },

  {
    path: 'login',
    name: 'login',
    meta: {
      requiresAuth: false,
      rule: 'isPublic',
      without_toolbar: true,
      isMenu: false,
      nolang: true,
    },
    caseSensitive: false,
  },
  {
    path: ':locale?/version',
    name: 'version',
    component: () => import('@/public/pages/Version.vue'),
    meta: {
      requiresAuth: false,
      rule: 'isPublic',
      without_toolbar: true,
      isMenu: false,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/test-formio',
    name: 'test-formio',
    component: () => import('@/public/pages/testPages/TestFormio.vue'),
    meta: {
      requiresAuth: false,
      rule: 'isGoodMode',
      without_toolbar: true,
      isMenu: false,
      nolang: true,
    },
    caseSensitive: false,
  },
  {
    path: ':locale?/test-page',
    name: 'test-page',
    component: () => import('@/public/pages/testPages/TestPage.vue'),
    meta: {
      requiresAuth: false,
      rule: 'isGoodMode',
      without_toolbar: true,
      isMenu: false,
      nolang: true,
    },
    caseSensitive: false,
  },
  {
    path: ':locale?/test-date',
    name: 'test-date',
    component: () => import('@/public/pages/testPages/TestDate.vue'),
    meta: {
      requiresAuth: false,
      rule: 'isGoodMode',
      without_toolbar: true,
      isMenu: false,
      nolang: true,
    },
    caseSensitive: false,
  },
  {
    path: ':locale?/test-math',
    name: 'test-math',
    component: () => import('@/public/pages/testPages/TestMath.vue'),
    meta: {
      requiresAuth: false,
      rule: 'isGoodMode',
      without_toolbar: true,
      isMenu: false,
      nolang: true,
    },
    caseSensitive: false,
  },
  {
    path: ':locale?/saved-settings',
    name: 'saved-settings',
    component: () => import('@/public/pages/PersonalSettingsPage.vue'),
    meta: {
      requiresAuth: false,
      rule: 'isPublic',
      without_toolbar: false,
      nolang: true,
    },
    caseSensitive: false,
  },
  {
    path: ':locale?/organizer-settings',
    name: 'organizerSettings',
    component: () => import('@/public/pages/OrganizerSettingsPage.vue'),
    meta: {
      rule: 'isGoodMode',
      caption: 'Menu.OrganizerSettings',
      requiresAuth: true,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/ip-filters',
    name: 'ipFilters',
    component: () => import('@/public/pages/IpFilters.vue'),
    meta: {
      rule: 'isGoodMode',
      caption: 'Menu.IpFilters',
      requiresAuth: true,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/growthbook-features',
    name: 'growthbookFeatures',
    component: () => import('@/public/pages/GrowthbookFeatures.vue'),
    meta: {
      rule: 'isGoodMode',
      caption: 'Menu.GrowthbookFeatures',
      needOrg: false,
      requiresAuth: true,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/events-stat',
    name: 'page-events-stat',
    component: () => import('@/public/pages/EventsStat.vue'),
    meta: {
      rule: 'isGoodMode',
      needOrg: false,
      requiresAuth: true,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/automation-events',
    name: 'page-automation-events',
    component: () => import('@/public/pages/AutomationEvents.vue'),
    meta: {
      rule: 'isGoodMode',
      needOrg: false,
      requiresAuth: true,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/purchasing',
    name: 'purchasing',
    component: () => import('@/public/pages/in menu/Purchasing.vue'),
    meta: {
      rule: 'tendersView',
      caption: 'Menu.Purchasing',
      isMenu: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false,
  },
  {
    path: ':locale?/:org(\\d+)/purchasing/new',
    name: 'catalog',
    component: () => import('@/public/pages/purchase/new purch/NewPurchase.vue'),
    meta: {
      rule: 'onlyApps',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/purchasing/edit',
    name: 'editing',
    component: () => import('@/public/pages/purchase/new purch/NewPurchase.vue'),
    meta: {
      rule: 'onlyApps',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/purchasing/:id',
    name: 'purchitem',
    component: () => import('@/public/pages/purchase/PurchaseItem.vue'),
    meta: {
      rule: 'onlyApps',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    props: {
      mode: 'purchasing'
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/planning',
    name: 'planning',
    component: () => import('@/public/pages/in menu/Planning.vue'),
    meta: {
      rule: 'tendersView',
      caption: 'Menu.Planning',
      isMenu: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/planning/:id',
    name: 'planitem',
    component: () => import('@/public/pages/purchase/ItemComponent.vue'),
    meta: {
      rule: 'onlyApps',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    props: {
      mode: 'planning'
    },
    caseSensitive: false
  },
  {
    path: ':locale?/contracting',
    name: 'contracting',
    meta: {
      rule: 'isPublic',
      caption: 'Menu.Contracting',
      casl: ['access', 'contracting'],
      isMenu: true,
      requiresAuth: true,
    },
    caseSensitive: false,
    beforeEnter() {
      let lng = router.app.$i18n.locale
      window.open(window.config.ContractingUrl + `?proj=it_${lng}&tz=3&par3=;ITCALL,/KEYMNU:DOG_EDIT/KBLS_T:_УКР`,'_blank')
    }
  },
  {
    path: ':locale?',
    redirect: {name: 'tenders'},
    name: 'rool',
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)',
    redirect: {name: 'tenders'},
    name: 'roolOrg',
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders',
    name: 'tenders',
    // alias: ':org(\\d+)?',
    component: () => import('@/public/pages/in menu/Tenders.vue'),
    meta: {
      rule: 'tendersView',
      caption: 'Menu.Tenders',
      needOrg: true,
      isMenu: true,
      requiresAuth: true
    },
    caseSensitive: false
  },

  {
    path: ':locale?/:org(\\d+)/tenders/new',
    name: 'newTender',
    component: () => import('@/public/pages/NewTender.vue'),
    meta: {
      rule: 'onlyTenders',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/edit',
    name: 'editTender',
    component: () => import('@/public/pages/NewTender.vue'),
    meta: {
      rule: 'onlyTenders',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:id(\\d+)',
    name: 'tenderitem',
    component: () => import('@/public/pages/tender item/TenderItemPanel.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId(\\d+)/:lotId(\\d+)',
    name: 'offersForLot',
    component: () => import('@/public/pages/tender item/OffersForLot.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId/:lotId?/compare',
    name: 'comparativeTable',
    component: () => import('@/public/pages/tender item/ComparativeTable.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId/:lotId?/check-winner',
    name: 'checkWinner',
    component: () => import('@/public/pages/tender item/CheckWinner.vue'),
    meta: {
      rule: 'onlyTenders',
      without_toolbar: true,
      requiresAuth: true,
      needOrg: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId/check-pre-qualification',
    name: 'checkPreQualification',
    component: () => import('@/public/pages/tender item/CheckWinner.vue'),
    meta: {
      rule: 'onlyTenders',
      without_toolbar: true,
      requiresAuth: true,
      needOrg: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId/bids-history',
    name: 'bidsHistory',
    component: () => import('@/public/pages/tender item/bid history/BidsHistory.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      requiresAuth: true,
      needOrg: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId/bids-history/lot/:lotId',
    name: 'bidsHistoryByLots',
    component: () => import('@/public/pages/tender item/bid history/BidHistoryByLot.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      requiresAuth: true,
      needOrg: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId/bids-history/lot/:lotId/compare',
    name: 'lotHistoryComparativeTable',
    component: () => import('@/public/pages/tender item/ComparativeTable.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId/bids-history/participants/:participantId',
    name: 'bidsHistoryByParticipants',
    component: () => import('@/public/pages/tender item/bid history/BidHistoryByParticipants.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      requiresAuth: true,
      needOrg: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:tenderId/bids-history/participants/:participantId/compare',
    name: 'participantHistoryComparativeTable',
    component: () => import('@/public/pages/tender item/ComparativeTable.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/stop-list',
    name: 'stopLists',
    component: () => import('@/public/pages/stop lists/StopList.vue'),
    meta: {
      rule: 'stopListView',
      caption: 'Menu.StopLists',
      needOrg: true,
      isMenu: true,
      link: '/stop-list',
      icon: 'stopped-person',
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/stop-list/add-new',
    name: 'addToStopList',
    component: () => import('@/public/pages/stop lists/AddToStopList.vue'),
    meta: {
      rule: 'stopListEdit',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/stop-list/:usreou',
    name: 'orgBlockingHistory',
    component: () => import('@/public/pages/stop lists/OrgBlockingHistory.vue'),
    meta: {
      rule: 'stopListView',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/suppliers',
    name: 'suppliers',
    component: () => import('@/public/pages/suppliers/Suppliers.vue'),
    meta: {
      rule: 'tendersView',
      caption: 'Menu.CRMSuppliers',
      isMenu: true,
      requiresAuth: true,
      needOrg: true,
      link: '/suppliers',
      icon: 'category',
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/suppliers/:id',
    name: 'supplier',
    component: () => import('@/public/pages/suppliers/Supplier.vue'),
    meta: {
      rule: 'tendersView',
      without_toolbar: true,
      requiresAuth: true,
      needOrg: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/group-of-accreditations',
    name: 'groupOfAccreditationsList',
    component: () => import('@/public/pages/group of accreditations/GroupOfAccreditationsList.vue'),
    meta: {
      rule: 'isPublic',
      caption: 'Menu.GroupOfAccreditations',
      needOrg: true,
      isMenu: true,
      link: '/group-of-accreditations',
      icon: 'table',
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/group-of-accreditations/new',
    name: 'groupOfAccreditationNew',
    component: () => import('@/public/pages/group of accreditations/GroupOfAccreditationCreateEdit.vue'),
    meta: {
      rule: 'isPublic',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/group-of-accreditations/:id',
    name: 'groupOfAccreditationsItem',
    component: () => import('@/public/pages/group of accreditations/GroupOfAccreditationItem.vue'),
    meta: {
      rule: 'isPublic',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/group-of-accreditations/edit/:id',
    name: 'groupOfAccreditationEdit',
    component: () => import('@/public/pages/group of accreditations/GroupOfAccreditationCreateEdit.vue'),
    meta: {
      rule: 'isPublic',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/additional-fields',
    name: 'additionalFieldsConstructor',
    component: () => import('@/public/pages/additional fields/AdditionalFieldsPage.vue'),
    meta: {
      rule: 'tenderAdmin',
      caption: 'Menu.AdditionalFieldsConstructor',
      needOrg: true,
      isMenu: true,
      link: '/additional-fields',
      icon: 'constructor',
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/additional-fields/add-new',
    name: 'addAdditionalField',
    component: () => import('@/public/pages/additional fields/AddAdditionalField.vue'),
    meta: {
      rule: 'tenderAdmin',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/additional-fields/edit/:id',
    name: 'editAdditionalField',
    component: () => import('@/public/pages/additional fields/AddAdditionalField.vue'),
    meta: {
      rule: 'tenderAdmin',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },


  {
    path: ':locale?/edit-releases',
    name: 'create-releases',
    component: () => import('@/public/pages/releases/CreateReleases.vue'),
    meta: {
      requiresAuth: true,
      rule: 'IT',
      caption: 'Releases.Releases',
      nolang: true,
    },
    caseSensitive: true
  },
  {
    path: ':locale?/features',
    name: 'releases',
    component: () => import('@/public/pages/releases/ClientReleases.vue'),
    meta: {
      requiresAuth: true,
      rule: 'isPublic',
      caption: 'Releases.AllModifications',
      nolang: true,
    },
    caseSensitive: true
  },
  {
    path: ':locale?/new-feature/:releaseId?/:id?',
    name: 'newFeature',
    component: () => import('@/public/pages/releases/NewFeature.vue'),
    meta: {
      requiresAuth: true,
      without_toolbar: true,
      nolang: true,
      rule: 'isAdmin',
    },
    caseSensitive: true
  },
  {
    path: ':locale?/analytic',
    name: 'analytic',
    redirect: {name: 'page-error', params: { status_code: 404, descript: 'analytic' }},
    // component: () => import('@/public/pages/in menu/NewTenders.vue'),
    meta: {
      rule: 'isPublic',
      caption: 'Menu.OrganizerAnalytic',
      isMenu: true,
      link: 'Menu.Link.OrganizerAnalytic',
      requiresAuth: true,
      icon: 'pie',
      externalLink: true,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: '',
    name: 'personalPriceAnalytics',
    redirect: {name: 'page-error', params: { status_code: 404, descript: 'personalPriceAnalytics' }},
    // component: () => import('@/public/pages/in menu/NewTenders.vue'),
    meta: {
      rule: 'isPublic',
      caption: 'Menu.PersonalPriceAnalytics',
      isMenu: true,
      link: 'Menu.Link.PersonalPriceAnalytics',
      requiresAuth: true,
      icon: 'insights',
      externalLink: true,
    },
    caseSensitive: false
  },
  {
    path: '',
    name: 'personalAnalytics',
    redirect: {name: 'page-error', params: { status_code: 404, descript: 'personalAnalytics' }},
    // component: () => import('@/public/pages/in menu/NewTenders.vue'),
    meta: {
      rule: 'isPublic',
      caption: 'Menu.PersonalAnalytics',
      isMenu: true,
      link: 'Menu.Link.PersonalAnalytics',
      requiresAuth: true,
      icon: 'poll',
      externalLink: true,
    },
    caseSensitive: false
  },

  {
    path: ':locale?/myaccreditedsuppliers',
    name: 'myaccreditedsuppliers',
    redirect: {name: 'page-error', params: { status_code: 404, descript: 'myaccreditedsuppliers' }},
    meta: {
      rule: 'isPublic',
      caption: 'Menu.MyAccreditedSuppliers',
      isMenu: true,
      link: 'Menu.Link.MyAccreditedSuppliers',
      casl: ['access', 'AccreditedSuppliers'],
      requiresAuth: true,
      icon: 'person-card',
      externalLink: true,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/risk indicators',
    name: 'risk indicators',
    redirect: {name: 'page-error', params: { status_code: 404, descript: 'risk indicators' }},
    meta: {
      rule: 'isPublic',
      caption: 'Menu.RiskIndicators',
      isMenu: true,
      link: 'Menu.Link.RiskIndicators',
      requiresAuth: true,
      icon: 'diagram',
      externalLink: true,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)?',
    name: 'homePage',
    meta: {
      rule: 'isPublic',
      isMenu: false,
    },
  },
  {
    path: ':locale?/error/:status_code/:type?',
    name: 'page-error',
    component: () => import('@/public/pages/Error.vue'),
    meta: {
      rule: 'isPublic',
      isMenu: false,
      nolang: true,
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/tenders/:id(\\d+)/tender-visits',
    name: 'tenderVisits',
    component: () => import('@/public/pages/tender item/TenderVisitsPanel.vue'),
    meta: {
      rule: 'isPublic',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/notifications',
    name: 'all-notification',
    component: () => import('@/public/pages/in menu/Notifications.vue'),
    meta: {
      rule: 'isPublic',
      needOrg: true,
      isMenu: false,
      caption: 'Menu.Notifications',
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/automations',
    name: 'automationsPage',
    component: () => import('@/public/pages/automation/AutomationsPage.vue'),
    meta: {
      group: 'automation',
      rule: 'tendersView',
      caption: 'Menu.Automation',
      needOrg: true,
      isMenu: true,
      link: '/automations',
      icon: 'circle-start',
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/automations/add-new',
    name: 'addAutomation',
    component: () => import('@/public/pages/automation/AddChangeAutomation.vue'),
    meta: {
      group: 'automation',
      rule: 'tendersView',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
  {
    path: ':locale?/:org(\\d+)/automations/edit/:id',
    name: 'editAutomation',
    component: () => import('@/public/pages/automation/AddChangeAutomation.vue'),
    meta: {
      group: 'automation',
      rule: 'tendersView',
      without_toolbar: true,
      needOrg: true,
      requiresAuth: true
    },
    caseSensitive: false
  },
]

const localization = location.pathname.replace(window.config.BaseUrl, '')
const language =  localization.toLowerCase().startsWith('/en/') ? 'en' : ''

routes.forEach(route => {
  if (language) {
    route.path = route.path.replace(':locale?', language)
  } else {
    route.path = route.path.replace(':locale?', '')
  }
})

let router = new VueRouter({
  mode: 'history',
  base: baseUrl,
  routes: [
    {
      path: '',
      meta: {
        rule: 'isPublic',
      },
      component: () => import('@/public/Layout.vue'),
      children: routes
    },
    {
      path: '*',
      name: '404',
      redirect: {name: 'page-error', params: { status_code: 404, descript: 'error page' }},
      meta: {
        rule: 'isPublic',
        nolang: true,
      },
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  to.params.locale = to.params.locale?.toLowerCase() || from.params.locale?.toLowerCase() || 'ua'
  to.meta.from = from

  let path = to.fullPath
  if (path.startsWith('/en/EN')) {
    to.params.locale = 'en'
  }
  const lang = ['', 'ua', 'en']
  if (to.params.locale === 'ru') { // Если язык русский, уходим на украинскую версию
    to.params.locale = null
    return next(to)
  } else if (!to.meta.nolang && !lang.includes(to.params.locale)) { // Если языка нет в списке, уходим на ошибку
    return next({name: 'page-error', params: { locale: 'ua', status_code: 404, descript: `код языка ${to.params.locale}` }})
  }

  if (to.params.locale === 'en' && path.startsWith('/en/EN')) {
    return next(path.slice(0, 3).toLowerCase() + path.slice(6))
  }
  // для украинских ссылок убираем префикс
  if (to.params.locale === 'ua' && path.startsWith('/ua')) {
    return next( path.slice(3))
  }
  let user = Vue.prototype.$store.getters.GET_USER
  if (to.name == 'login') {
    if (user && user.access_token) {
      if (user.expired) {
        let new_token = await Vue.prototype.$auth.renewToken(true)
        if ( !new_token ) {
          return next({name: 'login'})
        }
      }
      return next({ name: 'homePage'})
    } else {
      await Vue.prototype.$auth.signIn()
    }
  }
  if (from.name == 'tenderitem') {
    sessionStorage.removeItem('tender_step: from_plan')
  }

  let acl = router.app.$acl

  if (!user || !user.access_token) {
    user =  await Vue.prototype.$auth.getUser()
    if (user && user.access_token) {
      if (user.expired) {
        let new_token = await Vue.prototype.$auth.renewToken(true)
        if ( !new_token ) {
          return next({name: 'login'})
        }
      }

      if (!(to.params.status_code + '').startsWith('50') || store.getters.getSettings) {
        acl = router.app.$acl
        await Vue.prototype.$store.dispatch('LOGIN', { user, acl, router })
      }
    }
  }

  const requiresAuth = to?.matched?.some(record => record.meta.requiresAuth) // на new-tender немає атрибута і не загружаються сетінги і не змінюється акл
  if (to.name != 'homePage' && !requiresAuth && to.matched?.length) {
    return next()
  }

  if (!user || !user.access_token) {
    return next({name: 'login'})
  }

  let currentOrganization = Vue.prototype.$store.getters['getCurrentOrganization']
  let settings = Vue.prototype.$store.getters['getSettings']
  let org_id = currentOrganization?.organizationItId || from.params.org
  let org_params = { params: { org: org_id } }

  if (!settings?.hasPurchasingAccess && !settings?.hasTenderAccess) {
    return next({name: 'page-error', params: { status_code: 403, descript: 'пусто settings.hasPurchasingAccess и settings.hasTenderAccess' }})
  }
  if (to.meta.needOrg && !to.params.org && org_id ) {
    to.params.org = org_id
    return next(to)
  }
  if ( currentOrganization && Object.entries(currentOrganization).length) {
    if (to.name == 'tenders' && acl.not.check('tendersView')) {
      return next( Object.assign(org_params, { name: 'purchasing'}) )
    }
  } else if (to.meta.needOrg) {
    return next({name: 'page-error', params: { status_code: 403, descript: 'нет currentOrganization'}})
  }

  if (to.name == 'homePage' || !to.matched?.length ) {
    if ( currentOrganization && Object.entries(currentOrganization).length) {
      let path = Object.assign(org_params, { name: undefined } )
      if ( acl.check('tendersView') ) {
        path.name = 'tenders'
      } else if ( acl.check('onlyApps') ) {
        path.name = 'purchasing'
      }  else if ( acl.not.check('onlyApps') && acl.not.check('tendersView')) {
        return next({name: 'page-error', params: { status_code: 403, descript: 'нет роли onlyApps и нет роли tendersView'}})
      }
      if (from.name == path.name) {
        return to.params?.reload ? router.go() : next(path)
      } else {
        return next(path)
      }
    } else {
      return next({name: 'page-error', params: { status_code: 403, descript: 'нет currentOrganization'}})
    }
  }

  return next()
})
export default router
